import * as Sentry from '@sentry/nextjs';
import { getGlitchTipOptions } from './config/glitchtip';

Sentry.init({
  ...getGlitchTipOptions(),
  // The GlitchTip docs set `autoSessionTracking: false`. That option no longer exists in
  // SDK v8+; removing the session integration is the equivalent.
  integrations: (defaults) => defaults.filter((integration) => integration.name !== 'BrowserSession'),
});
